module.exports = __webpack_public_path__ + "img/威胁分析系统.4dee2865.png";